export interface CompanyOwnerDto {
  id?: string;
  ovmsItemId?: string | null;
  ovmsSecret?: string | null;
  ovmsStatus?: string | null;
}
